import { useQuery } from "@apollo/client";
import { MOMENTS } from "MVVM/GraphQL/matchHistory";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  MatchHistoryGame,
  MatchHistoryplayerToSearchFor,
  MomentsPlayerOverride,
} from "MVVM/State/matchHistory";
import { useGateValue } from "@statsig/react-bindings";
import { TPlayer } from "MVVM/Views/MatchHistory/@types";
import { analytics } from "MVVM/Analytics";

export const MomentsViewModel = (matchId?: string, limit?: number) => {
  const matchHistoryPlayerToSearchFor = useRecoilValue(
    MatchHistoryplayerToSearchFor,
  );
  const matchHistoryGame = useRecoilValue(MatchHistoryGame);
  const [momentsPlayerOverride, setMomentsPlayerOverride] = useRecoilState(
    MomentsPlayerOverride,
  );
  const showSecondaryMoments = useGateValue("secondary_moments");
  const { data, loading, fetchMore } = useQuery(MOMENTS, {
    variables: {
      matchId,
      playerGameId: momentsPlayerOverride || matchHistoryPlayerToSearchFor,
      sort: "SCORE",
      ...(limit && { limit: limit }),
      type: showSecondaryMoments ? "ALL" : "PRIMARY_ONLY",
    },
    skip: !matchId,
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  const requestOnDemandMoments = () => {
    fetchMore({
      variables: {
        onDemand: true,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        analytics.track("Match History - Get Moments", {
          totalMoments: fetchMoreResult.moments.length,
          game: matchHistoryGame,
          matchId,
          playerGameId: momentsPlayerOverride || matchHistoryPlayerToSearchFor,
        });
        return {
          ...prev,
          moments: [
            ...(prev.moments || []),
            ...(fetchMoreResult.moments || []),
          ],
        };
      },
    });
  };

  return {
    moments: data?.moments || [],
    loading,
    requestOnDemandMoments,
  };
};
